import { isArray, mergeWith } from "lodash";
import {
    disableTwoFactor as apiDisableTwoFactor,
    enableTwoFactor as apiEnableTwoFactor,
    getProfile as apiGetProfile,
    updateProfile as apiUpdateProfile,
} from "src/services/accountService";
import { RootState } from "src/store";
import { PartialDeep } from "type-fest";

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

type AccountState = {
    profile: API.Profile | null;
};

export const fetchProfile = createAsyncThunk("profile/fetch", apiGetProfile);
export const updateProfile = createAsyncThunk("profile/update", apiUpdateProfile);
export const enableTwoFactor = createAsyncThunk("profile/enable/2fa", apiEnableTwoFactor);
export const disableTwoFactor = createAsyncThunk("profile/disable/2fa", apiDisableTwoFactor);

const initialState: AccountState = {
    profile: null,
};

const initialWithLastPersistedState: AccountState = mergeWith(
    initialState,
    {
        // override anything from "initial-state" & "last-persisted-state" here
    },
    (obj: PartialDeep<AccountState>, src: PartialDeep<AccountState>) => {
        if (isArray(obj)) {
            return src;
        }
    },
);

const slice = createSlice({
    name: "account",
    initialState: initialWithLastPersistedState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchProfile.fulfilled, (state: AccountState, { payload }) => {
            if (payload) {
                state.profile = payload;
            }
        });
        builder.addCase(updateProfile.fulfilled, (state: AccountState, { payload, meta }) => {
            if (payload) {
                state.profile = meta.arg;
            }
        });
        builder.addCase(enableTwoFactor.fulfilled, (state) => {
            if (state.profile) {
                state.profile.twoFactorEnabled = true;
            }
        });
        builder.addCase(disableTwoFactor.fulfilled, (state) => {
            if (state.profile) {
                state.profile.twoFactorEnabled = false;
            }
        });
    },
});

export const selectProfile = (state: RootState): API.Profile | null => state.account.profile;

export default slice.reducer;
